// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SqAauv {
  flex: 1;
  min-height: 0;
  height: 100%;
  max-height: 550px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-3);
  padding-right: var(--spacing-2);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: var(--spacing-1);
  }
  &::-webkit-scrollbar-thumb {
    width: var(--spacing-1);
    background-color: var(--text-neutral-subtle);
    border-radius: var(--radius-m);
  }
}

.oxo2_l {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-0-5);
}

.xtd1oB {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.LlCYyF {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-3);
  width: 100%;
}

.eorfyk {
  height: 1px;
  width: 100%;
  /* Elemento invisível que será observado para detectar o scroll */
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayableList/AccountsPayableList.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,4CAA4C;IAC5C,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iEAAiE;AACnE","sourcesContent":[".extractList {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  max-height: 550px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-3);\n  padding-right: var(--spacing-2);\n  overflow-y: auto;\n  &::-webkit-scrollbar {\n    width: var(--spacing-1);\n  }\n  &::-webkit-scrollbar-thumb {\n    width: var(--spacing-1);\n    background-color: var(--text-neutral-subtle);\n    border-radius: var(--radius-m);\n  }\n}\n\n.extractGroup {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-0-5);\n}\n\n.date {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.loadingMore {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: var(--spacing-3);\n  width: 100%;\n}\n\n.scrollTrigger {\n  height: 1px;\n  width: 100%;\n  /* Elemento invisível que será observado para detectar o scroll */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"extractList": `SqAauv`,
	"extractGroup": `oxo2_l`,
	"date": `xtd1oB`,
	"loadingMore": `LlCYyF`,
	"scrollTrigger": `eorfyk`
};
module.exports = ___CSS_LOADER_EXPORT___;
